import "./styles/style.scss"

import { datadogRum } from "@datadog/browser-rum"
import { ReactKeycloakProvider } from "@react-keycloak/web"
import { AuthMonitor } from "auth"
import Keycloak from "keycloak-js"
import React from "react"
import { useDispatch } from "react-redux"
import { refreshToken } from "store/slices/user"
import { useExtension } from "utils"

import DefaultLayout from "./layouts/DefaultLayout"
import Routes from "./routes"

export default function App(props) {
  const dispatch = useDispatch()
  const realm = window.location.hostname.split(".")[0]
  const extension = useExtension()

  const datadogConfig = extension?.config?.env?.datadogConfig
  datadogRum.init(datadogConfig)

  const optionA = {
    url: "https://auth.opencloudportal.com/auth",
    realm: "Deloitte",
    clientId: "client_portal"
  }

  let keyCloakConfig
  if (realm === "cms" || realm === "localhost") {
    keyCloakConfig = keyCloakConfig = new Keycloak(optionA)
  } else {
    return (
      <>
        <h1>The Portal Does not exist. Please Contact Support.</h1>
      </>
    )
  }

  const keycloakInitOptions = {
    redirectUri: window.location.href,
    onLoad: "login-required",
    idpHint: "Deloitte"
  }

  if (window.location.hash.search("state") < 0) {
    keyCloakConfig.init()
    const loginUrl = keyCloakConfig.createLoginUrl(keycloakInitOptions)
    console.log("login url: ", loginUrl)
  }

  const onKeycloakEvent = (event) => {
    // console.log("onKeycloakEvent", event, error)
    if (event === "onTokenExpired") {
      console.log("Token Refreshing...")
      // dispatch(userActions.userTokenRefreshing())
      keyCloakConfig
        .updateToken(300)
        .then((refreshed) => {
          if (refreshed) {
            // console.log("Token Refreshed...")
            dispatch(refreshToken({ auth: keyCloakConfig }))
          } else {
            // console.log("Failed Refresh Token...")
          }
        })
        .catch((error) => {
          console.log("error: ", error)
        })
    }
  }

  // const onKeycloakTokens = (tokens) => {
  //   console.log("onKeycloakTokens", tokens)
  // }

  return (
    <ReactKeycloakProvider
      authClient={keyCloakConfig}
      initOptions={keycloakInitOptions}
      onEvent={onKeycloakEvent}
      // onTokens={onKeycloakTokens}
    >
      <AuthMonitor />
      <DefaultLayout {...props}>
        <Routes />
      </DefaultLayout>
      <div id="drawerHolder"></div>
      <div id="status-modal"></div>
      <div id="serv-req-modal"></div>
      <div id="serv-action-modal"></div>
      <div id="vuln-compilance-modal"></div>
      <div id="maintenance-modal"></div>
      {/* <h1><button onClick={() => keyCloakConfig?.logout()}>Logout</button></h1> */}
    </ReactKeycloakProvider>
  )
}
